import useApi, { USER_FORGOTTEN_PASSWORD } from 'hooks/useApi';

const useForgottenPasswordUtility = () => {
  const [, makeRequest] = useApi();

  const sendResetPasswordResetRequest = (emailAddress, baseUrl) => {
    makeRequest(USER_FORGOTTEN_PASSWORD({ emailAddress, baseUrl }));
  };

  return [sendResetPasswordResetRequest];
};
export default useForgottenPasswordUtility;
